// src/components/common/ResourceProgress.js
import React from 'react';
import { Box, Typography, LinearProgress, useTheme } from '@mui/material';

const ResourceProgress = ({ value, label, size = 'medium', showPercentage = true, width }) => {
  const theme = useTheme();
  
  // Determine color based on value
  let color;
  if (value > 90) {
    color = theme.palette.error.main;
  } else if (value > 75) {
    color = theme.palette.warning.main;
  } else {
    color = theme.palette.success.main;
  }
  
  // Determine height based on size
  let height, borderRadius;
  switch(size) {
    case 'small':
      height = 6;
      borderRadius = 3;
      break;
    case 'large':
      height = 12;
      borderRadius = 6;
      break;
    case 'medium':
    default:
      height = 8;
      borderRadius = 4;
  }
  
  return (
    <Box>
      {label && (
        <Typography variant="body2" color="text.secondary" gutterBottom>
          {label}
        </Typography>
      )}
      <Box display="flex" alignItems="center">
        <LinearProgress 
          variant="determinate" 
          value={value || 0} 
          sx={{ 
            height, 
            borderRadius, 
            bgcolor: `${theme.palette.background.default}cc`,
            width: width || '100%',
            flexGrow: width ? 0 : 1,
            '& .MuiLinearProgress-bar': {
              bgcolor: color,
              borderRadius,
            },
          }}
        />
        {showPercentage && (
          <Box
            sx={{
              ml: 1,
              px: 1,
              py: 0.25,
              borderRadius: 1,
              backgroundColor: `${color}1a`,
              color: color,
            }}
          >
            <Typography variant="body2" fontWeight="medium">
              {value?.toFixed(1) || 0}%
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default ResourceProgress;